module.exports = __webpack_public_path__ + "static/media/ZSBS10.e939b440.jpg";